
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[authorID]",
      function () {
        return require("private-next-pages/[authorID].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[authorID]"])
      });
    }
  